import { render, staticRenderFns } from "./NotificationCenter.vue?vue&type=template&id=370d2bd8&"
import script from "./NotificationCenter.vue?vue&type=script&lang=ts&"
export * from "./NotificationCenter.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationCenter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports